import { keepPreviousData, useQuery } from "@tanstack/react-query";
import UserNotification from "util/UserNotification";
import { TEAMS_QUERY_KEY, loadTeamsPaginated } from "../api/teams";
const useTeamsPaginated = (pagination) => useQuery({
  queryKey: [...TEAMS_QUERY_KEY, "paginated", pagination],
  queryFn: () => loadTeamsPaginated(pagination).catch((error) => {
    UserNotification.error(`Loading teams failed with status: ${error}`);
    throw error;
  }),
  placeholderData: keepPreviousData,
  retry: false
});
export default useTeamsPaginated;
